import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { trackPostHogEvent } from '../../utils/posthogUtils';
import styles from './Support.module.css';
import customerSupportImg from "../../assets/customer-support.webp";

function Support() {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);
    const meetRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        let currentElement = elementRef.current;
        if (currentElement) {
            observer.observe(currentElement);
        }
        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, []);
    
    function handleMeet() {

        // Track meet our team event

        trackPostHogEvent('landing_page_submitted', {
            selected: 'meet_our_team',
            to_path: '/about'
        });

        navigate('/about/');
    }

    function handleMeetHover(e) {
        e.target.classList.add('animate__animated', 'animate__pulse', styles.glowBlue);
    }
    function handleMeetHoverEnd(e) {
        e.target.classList.remove('animate__animated', 'animate__pulse', styles.glowBlue);
    }


    return (
        <div className={styles.supportSection}>
            <div ref={elementRef} className={styles.supportPanel} >
                <div className={styles.supportText + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>Customer Support at Your Fingertips</div>
                <div className={styles.supportSubtext}>Personalized prescription medication tailored to your unique goals. Clinician-approved nutrition and workout plans, along with regular check-ins to ensure your success!</div>
            </div>
            <div ref={meetRef} className={styles.meetButton} onMouseEnter={handleMeetHover} onMouseLeave={handleMeetHoverEnd} onClick={handleMeet}>Meet Our Team</div>
            <div className={styles.supportImageContainer}>
            <img src={customerSupportImg} alt="Customer Support" className={styles.supportImage + (isVisible ? ' animate__animated animate__fadeInUp' : '')} />
            </div>
        </div>
    );
}

export default Support;
